import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import enums from 'scoreboard/components/enums'
import template from './scorecard-structure-form.hbs'
import appDisplay from 'scoreboard/components/app-display'
import SelectScorecardView from './scorecard-structure-scorecard-dialog'
import ColumnsView from '../wizard/scorecard-structure/scorecard-structure-columns-dialog'
import ScorecardStructureModel from './scorecard-structure-model'
import formatValue from 'scoreboard/components/format-value'
import * as reportFormHelper from 'scoreboard/reports/common/report-form-helper'
import BaseReportEditForm from 'scoreboard/reports/common/base-report-form'
import assignLinkGroups from 'scoreboard/components/assign-link-groups'
import DataType from 'scoreboard/datasets/model/data-type'
const { YES_NO } = DataType

var ScorecardStructureForm = BaseReportEditForm.extend({

	className: 'table-hack-row display-pane-body',

	events: _.extend({
		'click .edit-descendant-of': 'editDescendantOf',
		'click .edit-columns': 'editColumns'
	}),

	initialize: function(options = {}) {
		this.options = options
		reportFormHelper.listenToChanges(this, ['filters', 'columns'])

		//ensure or groupings assigned
		assignLinkGroups(_.flatMap(this.model.get('filters')))
	},

	render: function() {
		var columns = this.model.get('columns')
		let showAbbreviatedValues = this.model.get('showAbbreviatedValues')

		let aif = _.get(this.model.attributes, 'filters.scorecardNodeIds[0]', {})
		this.nodeId = _.get(aif, 'ancestorValues[0]', null)
		var node = _.get(aif.metadata, this.nodeId, {})
		var followLinkedValue = formatValue({ value: aif.followLinked || false, dataType: YES_NO })
		var ctx = {
			label: this.model.get('label'),
			name: node.label,
			followLinkedValue: followLinkedValue,
			columns: [],
			showAbbreviatedValues
		}

		_.each(columns.columns, function(value) {
			ctx.columns.push({value: i18n.get(enums.scorecardReportColumnType[value])})
		})

		this.$el.html($(template(ctx)))
		this._initLabelField()

		this.$('.report-info').toggleClass('no-title', !!this.options.embedded)

		return this
	},

	editDescendantOf: function() {
		var model = new ScorecardStructureModel({
			filters: _.cloneDeep(this.model.get('filters'))
		})
		var selectScorecard = new SelectScorecardView({model: model})
		selectScorecard.on('done', function(m) {
			this.model.set('filters', m.get('filters'))
		}.bind(this))
		appDisplay.dialog(selectScorecard)
	},

	editColumns: function() {
		var model = new ScorecardStructureModel({columns: {
			columns: [].concat(this.model.get('columns').columns)}
		})
		var columnsView = new ColumnsView({model: model})
		columnsView.on('done', function() {
			this.model.set('columns', model.get('columns'))
		}.bind(this))
		appDisplay.dialog(columnsView)
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.label], 'remove')
	}

})

export default ScorecardStructureForm

ScorecardStructureForm.__filename__ = 'reports/scorecard-structure/scorecard-structure-form.js'
